import { Badge, Button, DatePicker, Dropdown, Form, Input, Select } from 'antd'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import queryString from 'query-string'
import React, { useEffect, useMemo, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Tuning2OutlineIcon } from '../../components/AppIcon'
import { checkValidFormFieldValue } from '../../utils/helper'

const { Option } = Select

const ReportPeriodicPageAdvanceFilterV2 = props => {
  const { finalData2 } = props || {}

  const [showFilter, setShowFilter] = useState(false)

  const history = useHistory()
  const location = useLocation()
  const queryStringParse = useMemo(
    () =>
      queryString.parse(location.search, {
        arrayFormat: 'index',
      }),
    [location.search]
  )

  const [form] = Form.useForm()
  const values = Form.useWatch([], form)
  const { setFieldsValue } = form

  const onToggleFilter = () => {
    setShowFilter(prev => !prev)
  }

  const hasFormValue = Object.values(values || {}).some(
    checkValidFormFieldValue
  )

  useEffect(() => {
    if (showFilter) {
      setFieldsValue({
        title: queryStringParse?.title || null,
        code: queryStringParse?.code || null,
        createdAt:
          queryStringParse?.createdAt && queryStringParse?.createdAt !== 'null'
            ? moment(queryStringParse.createdAt)
            : undefined,
      })
    }
  }, [queryStringParse, setFieldsValue, showFilter])

  const onFinish = values => {
    const params = {
      ...queryStringParse,
      title: values?.title || null,
      code: values?.code || null,
      createdAt: values?.createdAt
        ? moment(values?.createdAt).format('YYYY-MM-DD')
        : null,
      page: 0,
    }

    const queryStringStringify = queryString.stringify(params, {
      skipNull: true,
    })

    history.push(`${location.pathname}?${queryStringStringify}`)
    onToggleFilter()
  }

  const appliedFilterCount = useMemo(() => {
    let count = 0
    const hasValue = val => val && String(val).trim() !== '' && val !== 'null'

    if (hasValue(queryStringParse?.title)) count++
    if (hasValue(queryStringParse?.code)) count++
    if (hasValue(queryStringParse?.createdAt)) count++

    return count
  }, [queryStringParse])

  const handleClearFilter = () => {
    const params = {
      quarterly: queryStringParse?.quarterly,
    }
    const queryStringStringify = queryString.stringify(params, {
      skipNull: true,
    })
    history.push(`${location.pathname}?${queryStringStringify}`)
  }

  const removeVietnameseTones = str => {
    if (!str) return ''
    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '') // Bỏ dấu
      .replace(/đ/g, 'd')
      .replace(/Đ/g, 'D')
      .replace(/\s+/g, ' ') // Loại bỏ khoảng trắng
      .trim() // Loại bỏ khoảng trắng thừa
  }

  return (
    <Dropdown
      open={showFilter}
      onOpenChange={onToggleFilter}
      trigger={['click']}
      dropdownRender={() => (
        <div className="custom-page-filter-dropdown-container ">
          <Form form={form} onFinish={onFinish} layout="vertical">
            <div className="form-elements">
              <Form.Item
                label="Tiêu đề"
                name="title"
                style={{ marginBottom: 16 }}>
                <Input
                  placeholder="Tìm kiếm theo tiêu đề"
                  allowClear
                  className="h-40"
                />
              </Form.Item>

              <Form.Item
                label="Đơn vị"
                name="code"
                style={{ marginBottom: 16 }}>
                <Select
                  style={{
                    width: '100%',
                  }}
                  className="h-40"
                  showSearch
                  placeholder={'Tìm kiếm theo đơn vị'}
                  filterOption={(input, option) =>
                    removeVietnameseTones(
                      option?.children?.toLowerCase()
                    ).includes(removeVietnameseTones(input.toLowerCase()))
                  }
                  allowClear>
                  {finalData2?.map(item => (
                    <Option key={item.code} value={item.code}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="Ngày tạo"
                name="createdAt"
                style={{ marginBottom: 16 }}>
                <DatePicker
                  style={{ width: '100%' }}
                  allowClear
                  placeholder={'Tìm kiếm theo ngày tạo'}
                  format={'DD/MM/YYYY'}
                  className="h-40"
                />
              </Form.Item>
            </div>
            <div
              style={{
                marginTop: '5px',
                display: 'flex',
                gap: '10px',
                alignItems: 'center',
                justifyContent: hasFormValue ? 'space-between' : 'center',
                padding: '0 20px',
              }}>
              <Button
                className="custom-ant-button"
                type="primary"
                htmlType="submit">
                Áp dụng
              </Button>
              <Button
                className="custom-ant-button"
                htmlType="button"
                onClick={onToggleFilter}>
                Đóng
              </Button>

              <Button
                className="custom-ant-button"
                style={{
                  display: hasFormValue ? 'flex' : 'none',
                  marginLeft: 'auto',
                }}
                htmlType="reset"
                onClick={() => {
                  form.resetFields()
                  onToggleFilter()
                  handleClearFilter()
                }}>
                Xóa
              </Button>
            </div>
          </Form>
        </div>
      )}
      placement="bottomRight">
      <Badge count={appliedFilterCount} offset={[-6, -3]}>
        <Button
          title="Bộ lọc"
          className="custom-page-filter-dropdown-btn"
          icon={
            <Tuning2OutlineIcon
              style={{
                width: 16,
                height: 16,
              }}
            />
          }
        />
      </Badge>
    </Dropdown>
  )
}

export default inject(
  'reportStore',
  'loadingAnimationStore'
)(observer(ReportPeriodicPageAdvanceFilterV2))
